"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var reselect_1 = require("reselect");
var reducers_1 = require("./reducers");
var EMPTY_OBJ = {};
var EMPTY_ARRAY = [];
var _getRoot = function (state) { return state[reducers_1.ROOT_KEY] || EMPTY_OBJ; };
var _getBundleList = reselect_1.createSelector(_getRoot, function (root) { return root.bundleList || EMPTY_OBJ; });
exports.getBundle = function (state, code) { return _getBundleList(state)[code] || EMPTY_OBJ; };
exports.getBundleProperties = function (state, code) { return exports.getBundle(state, code).properties || EMPTY_OBJ; };
exports.getLocaleList = reselect_1.createSelector(_getRoot, function (root) { return root.localeList || EMPTY_ARRAY; });
var _localeFromList = function (localeList, code) {
    var localeRegexp = new RegExp("^" + code, 'i');
    return localeList.find(function (locale) { return localeRegexp.test(locale.code); }) || reducers_1.DEFAULT_LOCALE;
};
exports.getLocale = function (state, code) {
    if (code === void 0) { code = reducers_1.DEFAULT_LOCALE.code; }
    var localeList = exports.getLocaleList(state);
    return _localeFromList(localeList, code);
};
var _getUserLocaleCode = reselect_1.createSelector(_getRoot, function (root) { return root.userLocale || reducers_1.DEFAULT_LOCALE.code; });
exports.getUserLocale = reselect_1.createSelector(exports.getLocaleList, _getUserLocaleCode, function (localeList, code) { return _localeFromList(localeList, code); });
exports.getUserBundle = reselect_1.createSelector(exports.getUserLocale, _getBundleList, function (locale, bundle) { return get_1.default(bundle, locale.code + ".properties") || EMPTY_OBJ; });
exports.getStringFromBundle = function (bundle, key, replaceOptions) {
    if (bundle === void 0) { bundle = {}; }
    if (replaceOptions === void 0) { replaceOptions = null; }
    var value = bundle[key];
    if (typeof value !== 'string') {
        return "Missing locale value (" + key + ")";
    }
    return replaceOptions ? value.template(replaceOptions) : value;
};
exports.getGetString = reselect_1.createSelector(exports.getUserBundle, function (bundle) { return function (code, opts) { return exports.getStringFromBundle(bundle, code, opts); }; });
exports.getString = function (state, key, replaceOptions) {
    if (replaceOptions === void 0) { replaceOptions = null; }
    return exports.getGetString(state)(key, replaceOptions);
};
exports.hasUserBundle = function (state) { return !isEqual_1.default(exports.getUserBundle(state), EMPTY_OBJ); };
exports.hasBundle = function (state, code) { return !isEqual_1.default(exports.getBundle(state, code), EMPTY_OBJ); };
exports.hasBundleById = function (state, code, name) {
    if (!exports.hasBundle(state, code)) {
        return false;
    }
    return !!get_1.default(exports.getBundle(state, code), 'ids', []).find(function (b) { return b === code + "_" + name; });
};
//# sourceMappingURL=selectors.js.map